/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2024-08-20 17:24:57
 */
const rowsMob8 = {
    ballDistance: 29.2,
    diameter: 13,
    numRows: 8,
    yBonus: 25,
    yMult: 1.12,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [193.0973854471488, 193.20780409363857, 192.71105506711584, 192.85873588423752, 234.85556452670212, 193.21698169483838, 194.22901883819202, 236.07091774489683],
        1: [236.45017660738438, 236.4378657914661, 194.7574203260091, 192.43194302058316, 190.97261879596022, 192.82613049574428, 192.87556228932303, 193.27681306803927],
        2: [193.37132983663642, 236.95714306568934, 193.21734836922258, 192.4783016005249, 194.723073648805, 190.99796340899738, 191.07045245676878, 233.2915650085646],
        3: [234.49378215287715, 191.0164170268845, 235.30686389216777, 193.54171140989553, 235.87542116090466, 191.25850940341437, 191.2820469535041, 237.08753588465083],
        4: [192.78107622586188, 234.33899487777785, 235.55688538557305, 193.56250623736537, 192.53766261881964, 236.14127017885352, 235.405686579908, 191.02234644947524],
        5: [234.45940218485367, 190.93960474219875, 234.79650536574007, 192.39316418423599, 192.04950888299462, 192.56914456725096, 235.0457211684334, 192.663002603554],
        6: [235.66522403795858, 233.3054750495163, 235.52309435903922, 235.56792866665546, 194.75861500126294, 234.91328402748508, 234.92394419567418, 234.59188312776433],
        7: [233.7113683421015, 233.24323162738813, 233.1084985514648, 190.92821814122553, 233.92554171230577, 233.47069218299106, 193.08894306983456, 235.55723153924865],
        8: [233.93512986097346, 233.13754849140696, 235.04710140715278, 235.07191893875202, 234.79275743470862, 234.7841708017575, 233.85109141249472, 235.19747944698446],
        9: []
    }
};
export {rowsMob8 as default};
